import React from "react";
import { Container } from "react-bootstrap";
import "./Jumbotron.scss"; // Archivo SCSS para estilos

const Jumbotron = () => {
  return (
    <div className="jumbotron-custom">
      <Container className="text-center text-white">
        <h1 className="display-4">Macarena Pereira Abogada </h1>
        <p className="lead">Santiago, Curicó, Concepción</p>
      </Container>
    </div>
  );
};

export default Jumbotron;
